import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { routes } from '@/lib/routes';

export function NotFoundPage() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center max-w-md px-6">
        <AlertCircle className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
        <h1 className="text-2xl font-semibold mb-2">Page Not Found</h1>
        <p className="text-muted-foreground mb-6">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="space-y-2">
          <Button asChild>
            <Link to={routes.intakes}>Go to Intake Forms</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to={routes.kb}>Go to Knowledge Base</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}